// Generic authenticated JSON request utilities for EXT API writes.
// Auth mirrors the read side: Bearer token from sessionStorage +
// REACT_APP_APIKEY in the apikey header.

const API_KEY = process.env.REACT_APP_APIKEY || '';

export const authHeaders = () => {
	const token = sessionStorage.getItem('token');
	return {
		Authorization: `Bearer ${token}`,
		apikey: API_KEY,
		'Content-Type': 'application/json',
	};
};

export interface JsonRequestInit extends Omit<RequestInit, 'body'> {
	body?: unknown;
}

export const jsonRequest = async <T = unknown>(url: string, init: JsonRequestInit): Promise<T> => {
	const { body, headers, ...rest } = init;
	const res = await fetch(url, {
		...rest,
		headers: { ...authHeaders(), ...(headers || {}) },
		body: body != null ? JSON.stringify(body) : undefined,
	});
	const json = (await res.json().catch(() => ({}))) as { error?: { message?: string } } & T;
	if (!res.ok || (json && (json as { error?: unknown }).error)) {
		const message = json?.error?.message || `Request failed: ${res.status}`;
		throw new Error(message);
	}
	return json as T;
};
